
export const basicFormData = () => ({
  inputData: {
    technician_id: "",
    material_id: "",
    available_qty: "",
    return_qty: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_stock_returns",
    schema: schema,
    "include": [
      {
        "model": "user_masters",
        "as": "technician"
      },
      {
        "model": "material_masters",
        "as": "material"
      }
    ]
  };

  const navigatePage = { back: "/technician-stock-return-list" };

  const headerName = "Technician Stock Return";

  const validationType = "TechnicianStockReturnCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    "modelName": "technician_stock_returns",
    "schema": schema,
    "include": [
      {
        "model": "user_masters",
        "as": "technician"
      },
      {
        "model": "material_masters",
        "as": "material"
      }
    ]
  };

  const navigatePage = {
    create: "/technician-stock-return-create",
    edit: "/technician-stock-return-create",
    view: "/technician-stock-return-view",
  };

  const searchfields = [
    "technician.first_name",
    "technician.last_name",
    "material.name",
    // "quantity",
  ];

  const headerName = "Technician Stock Return";
  const endpoint = "/getRecords";
  const exportFileName = "TechnicianStockReturnData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
  };
};
